// extracted by mini-css-extract-plugin
module.exports = {"icon":"EmbedShareTriggers_icon__gVCUE","playerIconContainer":"EmbedShareTriggers_playerIconContainer__Q__Pt"};